import type { Ref } from "vue";
import { onMounted } from "vue";

import { registerDrag } from "@/components/gestures/drag";
import type { Card } from "@/model/card";
import { isLinkDrag } from "@/utils/dom/dom";

import { stickyDragHandler } from "./stickyDragHandler";

export type Props = Readonly<{
  el?: Ref<HTMLDivElement | null>;
  card: Card;
  disabled?: Ref<Readonly<boolean>>;
}>;

export function useDrag({ el, card, disabled }: Props) {
  onMounted(() => {
    if (disabled?.value) return;
    el?.value?.addEventListener("pointerdown", handlePointerDown);
  });

  const handlePointerDown = (event: PointerEvent) => {
    if (disabled?.value || isLinkDrag(event)) return;
    registerDrag(event, stickyDragHandler(event, card, onDragEnd));
  };

  const onDragEnd = () => {
    // Prevent the focus ring from appearing if you shift-select after dragging
    el?.value?.setAttribute("data-blur-on-shift", "true");
    el?.value?.addEventListener("focusin", () => el?.value?.removeAttribute("data-blur-on-shift"), {
      once: true,
    });
  };
}
